<template>
<div class="form-body">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
            <label class="control-label col-md-3">Kwota</label>
            <div class="col-md-9">
                <input v-model="price" class="form-control" type="number" step="0.01" min="0.01">
            </div>
            <div v-show="priceError" :style="{ color: 'red', margin: '10px, 0, 0, 15px' }">
                Kwota musi być większa od zera
            </div>
            <div v-show="priceMaxError" :style="{ color: 'red', margin: '10px, 0, 0, 15px' }">
                Kwota nie może być większa od kwoty pozostałej do zapłaty.
            </div>
        </div>
      </div>
      <div class="col-sm-6">
        <number-input
                v-model="time"
                name="activityTime"
                title="Czas aktywności linka (h)"
        ></number-input>
      </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div v-show="surchargeUri != ''" class="surcharge-uri">{{ surchargeUri }}</div>
        </div>
    </div>
</div>
</template>

<script>
import NumberInput from '../../component/dccore-form/numberInput.vue'
import axios from 'axios'

export default {
  components: {
    NumberInput,
  },
  props: {
    orderId: {
      type: [String, Number],
      default:null,
    },
    maxPrice: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      surchargeUri: '',
      price: '0.00',
      time: 48,
      priceError: false,
      priceMaxError: false
    }
  },
  watch: {
    'price': function(newVal) {
      if (newVal > this.maxPrice) {
        this.priceMaxError = true
        this.$emit('button-disable', true)
      } else {
        this.priceMaxError = false
        this.$emit('button-disable', false)
      }
    }
  },
  methods: {
    async generateSurchargeUri(orderId) {
      if (this.price <= 0) {
        this.priceError = true
        return
      } else {
        this.priceError = false
      }
      let url = Routing.generate('frontend_order_payment_surcharge', {
        id: orderId,
        price: parseFloat(this.price),
        time: this.time * 3600
      })
      const response = await axios.get(
        url, {}
      )
      this.surchargeUri = response.data.surchargeUri
    },
  }
}
</script>

<style>
.modal-backdrop.show {
    opacity: .5;
}

div.modal .modal-dialog {
    width: 1200px !important;
}

.surcharge-uri {
    word-break: break-word;
}
</style>
